module.exports = __webpack_public_path__ + "img/lg.e77be80.jpg";